import React from "react";
import DefaultCard from "./DefaultCard";
import ListicleCard from "./ListicleCard";

interface FormatCardProps {
  content: any;
}

const cardRegistry: Record<string, React.FC<{ content: any }>> = {
  listicle: ListicleCard,
};

const FormatCard: React.FC<FormatCardProps> = ({ content }) => {
  const slug = content?.content_format?.slug;
  const CardComponent = slug && cardRegistry[slug] ? cardRegistry[slug] : DefaultCard;
  return <CardComponent content={content} />;
};

export default FormatCard;
